import { WaterUnitOperation } from './water-unit-operation';
import { unitOperationsConfig } from '../../../_config/unit-operations.config';
import { Case } from '../../case';
import { SimulationVariable } from '../../simulation-variable';
import { Quantity } from '../../../_config/quantity.enum';
import { TemperatureCalculationMode } from '../../../_config/temperature-calculation-mode.enum';
import { SimulationVariableName } from '../../../_config/simulation-variable-name.enum';
import { KpiProvider } from '../../_case-study/kpi-provider';
import { ParameterProvider } from '../../_case-study/parameter-provider';

declare let unitConverter: any;

export class WaterHeater extends WaterUnitOperation implements KpiProvider, ParameterProvider {
  category = unitOperationsConfig.waterHeater.key;
  temperatureGain: SimulationVariable;
  pressureDrop: SimulationVariable;
  duty: SimulationVariable;
  outletTemperature: SimulationVariable;
  temperatureCalculationMode: TemperatureCalculationMode | string;

  constructor(unitOperation: any | WaterHeater, ownerCase: Case) {
    super(unitOperation, ownerCase);
    this.initValues(unitOperation);
    this.setSimulationVariableNames();
  }

  override initValues(unitOperation: any) {
    super.initValues(unitOperation);
    this.temperatureGain = new SimulationVariable(unitOperation.temperatureGain, this.ownerCase, this);
    this.pressureDrop = new SimulationVariable(unitOperation.pressureDrop, this.ownerCase, this);
    this.duty = new SimulationVariable(unitOperation.duty, this.ownerCase, this);
    this.outletTemperature = new SimulationVariable(unitOperation.outletTemperature, this.ownerCase, this);
    this.temperatureCalculationMode = unitOperation.temperatureCalculationMode || '';
  }

  override clearResults() {
    super.clearResults();
    this.duty.value = null;
  }

  override setSimulationVariableNames() {
    super.setSimulationVariableNames();
    this.temperatureGain.setName(SimulationVariableName.TEMPERATURE_GAIN);
    this.pressureDrop.setName(SimulationVariableName.PRESSURE_DROP);
    this.duty.setName(SimulationVariableName.DUTY);
    this.outletTemperature.setName(SimulationVariableName.OUTLET_TEMPERATURE);
  }

  override setQuantities() {
    super.setQuantities();
    this.temperatureGain.setQuantity(Quantity.DELTA_TEMPERATURE);
    this.pressureDrop.setQuantity(Quantity.DELTA_PRESSURE);
    this.duty.setQuantity(Quantity.POWER);
    this.outletTemperature.setQuantity(Quantity.TEMPERATURE);
  }

  override setDefaultValues() {
    super.setDefaultValues();
    if (this.temperatureCalculationMode === '') {
      this.temperatureCalculationMode = TemperatureCalculationMode.TEMPERATURE_GAIN;
    }
    if (this.pressureDrop.isUndefined()) {
      this.pressureDrop.setDefaultValue(0.0);
    }
    if (this.duty.isUndefined()) {
      this.duty.setDefaultValue(null, unitConverter.units.Power.KW);
    }
    if (this.outletTemperature.isUndefined()) {
      this.outletTemperature.setDefaultValue(null, unitConverter.units.Temperature.CELSIUS);
    }
  }

  getAvailableKpis(): SimulationVariable[] {
    if (this.ownerCase.multiPeriodEnabled) {
      return [this.temperatureGain, this.duty];
    }
    return [this.temperatureGain, this.pressureDrop, this.duty];
  }

  getAvailableParametricStudyParameters(): SimulationVariable[] {
    return [this.pressureDrop];
  }

  getAvailableParameters() {
    return undefined;
  }

  override dePersist(unitOperation: any) {
    super.dePersist(unitOperation);
    this.temperatureGain = this.getSimulationVariableSafe(unitOperation.temperatureGain);
    this.pressureDrop = this.getSimulationVariableSafe(unitOperation.pressureDrop);
    this.duty = this.getSimulationVariableSafe(unitOperation.duty);
    this.outletTemperature = this.getSimulationVariableSafe(unitOperation.outletTemperature);
    this.setQuantities();
    this.setDefaultValues();
  }
}
